import _ from 'lodash'
import { _projectAppNames, envTypes, getFbConfig } from "../../project/appConfiguration"
import { _appSettingsOriginTypes, _appVersion, _settingSourceTypes } from '../cnr/contexts/ServiceWorkerContext'
import { frameworkDashboardTypes, frameworkLeftTypes } from "../cnr/reducers/FrameworkReducer"
import { leftMenuTriggerTypes, leftMenuTypes } from '../cnr/reducers/LeftMenuReducer'
import { allDataModes, allDataModes_client, allDataModes_event, allDataModes_home } from "../components/viewers/AppDashboard"
import { mobileDeviceTypes } from "../devices"
import { appIconTypes } from "../enums/appIconTypes"
import { gEnums } from "../enums/globalEnums"
import { settingsIconTypes } from "../enums/settingsIconTypes"
import { getDataSourceItem } from "../page/DataSourceSelect"

const _optionTypes = {
  action: 'action',
  admin: 'admin',
  admins: 'admins',
  appAdmin: 'appAdmin',
  appAdmins: 'appAdmins',
  appHistory: 'appHistory',
  appInfo: 'appInfo',
  appInfos: 'appInfos',
  appUser: 'appUser',
  appUsers: 'appUsers',
  dashboard: 'dashboard',
  dashboards: 'dashboards',
  dataOrigin: 'dataOrigin',
  dataSource: 'dataSource',
  device: 'device',
  devices: 'devices',
  external: 'external',
  externals: 'externals',
  home: 'home',
  overrides: 'overrides',
  user: 'user',
  users: 'users',
};

export const appOptions_left = {
  action: (handlers, settings) => options_action(handlers, settings),
  actions: (handlers, settings) => options_actions(handlers, settings),
  admin: (handlers, settings) => options_admin(handlers, settings),
  admins: (handlers, settings) => options_admins(handlers, settings),
  appAdmin: (handlers, settings) => options_appAdmin(handlers, settings),
  appAdmins: (handlers, settings) => options_appAdmins(handlers, settings,),
  appHistory: (handlers, settings) => options_appHistory(handlers, settings),
  appInfos: (handlers, settings) => options_appInfos(handlers, settings),
  appUser: (handlers, settings) => options_appUser(handlers, settings),
  appUsers: (handlers, settings) => options_appUsers(handlers, settings),
  confirmAction: (handlers, settings) => options_confirmation(handlers, settings),
  confirmation: (handlers, settings) => options_confirmation(handlers, settings),
  dashboard: (handlers, settings) => options_dashboard(handlers, settings),
  dashboards: (handlers, settings) => options_dashboards(handlers, settings),
  dataOrigin: (handlers, settings) => options_dataOrigin(handlers, settings),
  dataOrigins: (handlers, settings) => options_dataOrigins(handlers, settings),
  dataSource: (handlers, settings) => options_dataSource(handlers, settings),
  dataSources: (handlers, settings) => options_dataSources(handlers, settings),
  device: (handlers, settings) => options_device(handlers, settings),
  devices: (handlers, settings) => options_devices(handlers, settings),
  external: (handlers, settings) => options_external(handlers, settings),
  externals: (handlers, settings) => options_externals(handlers, settings),
  home: (handlers, settings) => options_home(handlers, settings),
  input: (handlers, settings) => options_input(handlers, settings),
  overrides: (handlers, settings) => options_overrides(handlers, settings),
}

const optionAccess = (settings, optionType) => {

  const accessLevel = settings?.appUserAccess?.accessLevel

  switch (optionType) {
    case _optionTypes.appInfo:
    case _optionTypes.appInfos:
    case _optionTypes.appHistory:
    case _optionTypes.dashboard:
    case _optionTypes.dashboards:
    case _optionTypes.device:
    case _optionTypes.devices:
      return accessLevel >= gEnums.accessLevels.appAdmin.value

    case _optionTypes.action:
    case _optionTypes.appUser:
    case _optionTypes.appUsers:
    case _optionTypes.dataOrigin:
    case _optionTypes.dataSource:
    case _optionTypes.external:
    case _optionTypes.externals:
    case _optionTypes.home:
    case _optionTypes.overrides:
    case _optionTypes.user:
    case _optionTypes.users:
      return accessLevel >= gEnums.accessLevels.superAdmin.value

    case _optionTypes.appAdmins:
    case _optionTypes.appAdmin:
    case _optionTypes.admin:
    case _optionTypes.admins:
      return false

    default:
      // Handle default case 
      return false
  }
}

const getOptions = (oc, currentIcon, cornerIcon, item, updating, iconColor, opts) => ({
  default: {
    text: item && item.text,
    caption: item && item.text,
    icon: item && item.icon,
    color: item && item.color,
    lmt: item && item.lmt,
    frt: item && item.frt,
    oc: oc,
    dividerBefore: true,
  },
  action: {
    text: 'Action',
    icon: 'wizard',
    lmt: leftMenuTypes.actions,
    oc: oc,
    dividerBefore: true
  },
  admin: {
    text: 'Admin Options',
    icon: 'options',
    color: 'orange',
    lmt: leftMenuTypes.admins,
    oc: oc,
    dividerBefore: true,
  },
  appAdmin: {
    text: 'App Admin Options',
    icon: 'options',
    color: 'purple',
    lmt: leftMenuTypes.appAdmins,
    oc: oc,
  },
  appHistory: {
    text: 'App History',
    icon: 'history',
    color: 'yellow',
    lmt: leftMenuTypes.appHistory,
    oc: oc,
  },
  appInfo: {
    text: 'App Info',
    icon: 'info circle',
    color: 'blue',
    lmt: leftMenuTypes.appInfos,
    oc: oc,
    dividerBefore: true
  },
  appUser: {
    text: 'App User',
    icon: currentIcon && currentIcon.name,
    color: currentIcon && currentIcon.color,
    lmt: leftMenuTypes.appUsers,
    oc: oc,
    dividerBefore: true,
    opts,
  },
  confirmation: {
    text: 'Confirm Action',
    icon: 'check',
    color: 'green',
    lmt: leftMenuTypes.confirmAction,
    frt: 'confirmAction',
    oc: oc,
    dividerBefore: true,
    showCaption: true
  },
  dashboard: {
    text: 'App Dashboard',
    icon: appIconTypes.appDashboard,
    lmt: leftMenuTypes.dashboards,
    oc: oc,
    dividerBefore: true
  },
  dataOrigin: {
    text: 'Data Origin',
    icon: 'database',
    color: iconColor,
    lmt: leftMenuTypes.dataOrigins,
    oc: oc,
    updating,
  },
  dataSource: {
    text: 'Data Source',
    icon: 'server',
    color: iconColor,
    lmt: leftMenuTypes.dataSources,
    oc: oc,
    iconCorner: cornerIcon && cornerIcon.icon,
    iconCornerColor: cornerIcon && cornerIcon.color,
    showIconCorner: true,
    updating,
    opts,
  },
  device: {
    text: 'Device',
    icon: settingsIconTypes.tv,
    color: 'grey',
    lmt: leftMenuTypes.devices,
    oc: oc,
    dividerBefore: true
  },
  external: {
    text: 'Open External',
    icon: 'external alternate',
    color: 'orange',
    lmt: leftMenuTypes.externals,
    oc: oc,
    dividerBefore: true
  },
  gotoExternal: {
    text: item && item.text,
    showCaption: true,
    icon: item && item.icon,
    color: item && item.color,
    lmt: item && item.lmt,
    oc: oc
  },
  input: {
    text: 'GS Key',
    icon: 'check',
    color: 'green',
    // lmt: leftMenuTypes.confirmInput,
    // frt: 'confirmAction',
    oc: oc,
    dividerBefore: true,
    showCaption: true,
    showInput: true,
  },
});

const options_appInfos = (handlers, settings) => {

  const { handleSet_currentMenuType: hs_cmt, handle_triggerAction: h_ta } = handlers ?? {}
  const { app_state, aps_global, deferredPrompt, appName, startIcon, registration, registrationSuccess } = settings ?? {}
  const showCaption = true

  // const { appInfo, mainApp, mainAuth, mainDb, mainRt } = app_state ?? {} 
  const _databaseId = _.get(app_state, 'mainDb._databaseId.projectId')
  const _realtimeId = _.get(app_state, 'mainRt.app._options.databaseURL')
  const authDomain = _.get(app_state, 'mainAuth.config.authDomain', null)
  const functionsDomain = _.get(app_state, 'mainFunctions.app._options.authDomain', null)
  // const scriptURL = _.get(app_state, 'mainMessaging.swRegistration.active.scriptURL', null)

  const trueConfig = getFbConfig()
  const { projectId } = trueConfig ?? {}
  const { topMenu, display, appAccess } = aps_global ?? {}
  const { mainFixedCaption } = topMenu ?? {}
  const { appAccessType } = appAccess ?? {}
  const { timeZone } = display ?? {}

  const opts = []
  appName && opts.push({ text: 'App Name: ', description: appName, icon: 'sitemap', showCaption })
  startIcon && opts.push({ text: 'Start Icon', src: startIcon?.fileUrl?.fileUrl, icon: 'globe' })
  mainFixedCaption && opts.push({ text: 'Event: ', description: mainFixedCaption, icon: 'info circle', showCaption })
  projectId && opts.push({ text: 'App Database: ', description: projectId, icon: 'database', showCaption })
  _databaseId && opts.push({ text: 'Database ID: ', description: _databaseId, icon: 'database', showCaption })
  _realtimeId && opts.push({ text: 'Realtime ID: ', description: _realtimeId, icon: 'clock outline', showCaption })
  authDomain && opts.push({ text: 'Auth Domain: ', description: authDomain, icon: 'id badge outline', showCaption })
  functionsDomain && opts.push({ text: 'Functions Domain: ', description: functionsDomain, icon: 'code', showCaption })
  // scriptURL && opts.push({ text: 'Messaging scriptURL: ', description: scriptURL, icon: 'send', showCaption })
  timeZone && opts.push({ text: 'Time Zone: ', description: timeZone, icon: 'clock', showCaption })
  opts.push({ text: 'App Access: ', description: appAccessType ? _.startCase(appAccessType) : 'None', icon: 'key', dividerBefore: true, showCaption })
  opts.push({ text: 'Installable: ', description: deferredPrompt ? 'Yes' : 'No', icon: 'cloud download', dividerBefore: true, showCaption })
  _appVersion && opts.push({ text: 'Version: ', description: _appVersion, icon: 'hashtag', showCaption })
  registration && opts.push({ text: 'SWR: ', description: registration?.scope, icon: registrationSuccess ? 'check circle' : 'circle outline', showCaption })

  // _.forEach(fn_cls, (fn) => {
  //   // console.log('fn', fn?.name)
  //   opts.push({ text: '> ', description: fn?.name, icon: 'code', frt: fn, oc: h_ta, lmt: leftMenuTriggerTypes.appFunction })
  //   // opts.push({ description: fn?.name, icon: 'code' })
  // })

  opts.unshift(...closers(getOptions(hs_cmt).appInfo, hs_cmt))
  return optionAccess(settings, _optionTypes.appInfo) && opts
}

const options_appHistory = (handlers, settings) => {
  const { handleSet_currentMenuType: hs_cmt, handle_triggerAction: h_ta } = handlers ?? {}
  const { appHistory } = settings ?? {}
  const opts = []
  if (appHistory) {
    _.forEach(appHistory, (h, hk) => {
      opts.push({ text: hk, oc: h_ta, icon: 'history', frt: h, showCaption: true, path: h, lmt: leftMenuTriggerTypes.appHistory })
    })
  }
  opts.unshift(...closers(getOptions(hs_cmt).appHistory, hs_cmt))
  return optionAccess(settings, _optionTypes.appHistory) && opts
}

const options_input = (handlers, settings) => {
  const { handleSet_currentMenuType: hs_cmt, handle_triggerAction: h_ta } = handlers ?? {}
  const opts = [{ ...getOptions(h_ta).input }]
  opts.unshift(...closers(getOptions(hs_cmt, { name: 'users' }).input, hs_cmt))
  return optionAccess(settings, _optionTypes.users) && opts
}

const options_confirmation = (handlers, settings) => {
  const { handleSet_currentMenuType: hs_cmt, handle_triggerAction: h_ta } = handlers ?? {}
  const opts = [{ ...getOptions(h_ta).confirmation }]
  opts.unshift(...closers(getOptions(hs_cmt, { name: 'users' }).confirmation, hs_cmt))
  return optionAccess(settings, _optionTypes.users) && opts
}

const options_admin = (handlers, settings) => {
  const { handleSet_currentMenuType: hs_cmt } = handlers ?? {}
  const { currentIcon } = settings ?? {}
  return optionAccess(settings, _optionTypes.admin) && [{ ...getOptions(hs_cmt, currentIcon).admin }]
}

const options_appAdmin = (handlers, settings) => {
  const { handleSet_currentMenuType: hs_cmt } = handlers ?? {}
  const { currentIcon } = settings ?? {}
  return optionAccess(settings, _optionTypes.appAdmin) && [{ ...getOptions(hs_cmt, currentIcon).appAdmin }]
}

const options_appUser = (handlers, settings) => {
  const { handleSet_currentMenuType: hs_cmt } = handlers ?? {}
  const { currentIcon, isClone } = settings ?? {}
  return optionAccess(settings, _optionTypes.appUser) && [{ ...getOptions(hs_cmt, currentIcon, null, null, null, null, { ocn: isClone ? 'blink_me_2' : null }).appUser }]
}

const options_device = (handlers, settings) => {
  const { handleSet_currentMenuType: hs_cmt } = handlers ?? {}
  return optionAccess(settings, _optionTypes.device) && [{ ...getOptions(hs_cmt).device }]
}

const options_external = (handlers, settings) => {
  const { handleSet_currentMenuType: hs_cmt } = handlers ?? {}
  return optionAccess(settings, _optionTypes.external) && [{ ...getOptions(hs_cmt).external }]
}

const options_action = (handlers, settings) => {
  const { handleSet_currentMenuType: hs_cmt } = handlers ?? {}
  return optionAccess(settings, _optionTypes.action) && [{ ...getOptions(hs_cmt).action }]
}

const options_dataOrigin = (handlers, settings) => {
  const { handleSet_currentMenuType: hs_cmt } = handlers ?? {}
  const { updating, appDataSource } = settings ?? {}
  const { useAppDataDocuments, useAppDataDocumentsOnly } = appDataSource ?? {}
  const opts = []
  let iconColor = useAppDataDocuments ? 'blue' : 'grey'
  // if (useAppDataDocumentsOnly) { iconColor = 'green' }
  opts.push({ ...getOptions(hs_cmt, null, null, null, updating, iconColor).dataOrigin })
  return optionAccess(settings, _optionTypes.dataOrigin) && opts
}

const options_dataSource = (handlers, settings) => {
  const { handleSet_currentMenuType: hs_cmt, handle_triggerAction: h_ta } = handlers ?? {}
  const { updating, _appDataSourceType, appDataSource } = settings ?? {}
  const { useAppDataDocuments, useAppDataDocumentsOnly } = appDataSource ?? {}
  const opts = []
  let iconColor_main = useAppDataDocuments ? 'grey' : 'grey'
  let iconColor = useAppDataDocuments ? 'blue' : 'grey'
  if (useAppDataDocumentsOnly) { iconColor = 'green' }

  const cornerIcon = { icon: getDataSourceItem(_appDataSourceType ? _appDataSourceType : gEnums.dataSourceTypes.firebase), color: iconColor }
  opts.push({ ...getOptions(hs_cmt, null, cornerIcon, null, updating, iconColor_main, { ocn: _appDataSourceType }).dataSource })

  switch (_appDataSourceType) {
    case gEnums.dataSourceTypes.googleSheet:
      opts.push({ text: 'Refresh Google Sheets', icon: 'refresh', color: 'grey', oc: h_ta, lmt: leftMenuTriggerTypes.triggerAction, frt: frameworkLeftTypes.refreshGoogleSheets })
      break;
    default:
    // nothing
  }
  return optionAccess(settings, _optionTypes.dataSource) && opts
}

const options_devices = (handlers, settings) => {
  const { handleSet_currentMenuType: hs_cmt, handle_triggerAction: h_ta } = handlers ?? {}
  const { currentAppDevice } = settings ?? {}
  const { key } = currentAppDevice ?? {}
  const mds = mobileDeviceTypes()
  const opts = mds.map(item => (
    { key: item.key, value: item.value, oc: h_ta, lmt: leftMenuTriggerTypes.device, frt: item.value, caption: _.startCase(item.text), text: _.startCase(item.text), icon: item.key === 'desktop' ? settingsIconTypes.tv : 'mobile alternate', color: key === item.key ? 'blue' : 'grey' }
  ))
  opts.unshift(...closers(getOptions(hs_cmt).device, hs_cmt))
  return optionAccess(settings, _optionTypes.device) && opts
}

const options_appUsers = (handlers, settings) => {
  const { handleSet_currentMenuType: hs_cmt, handle_triggerAction: h_ta } = handlers ?? {}
  const opts = []
  _.forEach(gEnums.accessLevels, (accessLevel) => {
    const { caption, color, icon } = accessLevel
    opts.push({ text: caption, icon, oc: h_ta, color, dividerBefore: true, caption: caption, frt: accessLevel, lmt: leftMenuTriggerTypes.appUserAccess })
  })
  opts.push({ text: 'Reset', icon: 'refresh', oc: h_ta, color: 'blue', caption: 'Reset', frt: { value: 'r' }, lmt: leftMenuTriggerTypes.appUserAccess })
  opts.unshift(...closers(getOptions(hs_cmt, { name: 'users' }).appUser, hs_cmt))
  return optionAccess(settings, _optionTypes.appUser) && opts
}

const options_dataOrigins = (handlers, settings) => {
  const { handleSet_currentMenuType: hs_cmt, handle_triggerAction: h_ta } = handlers ?? {}
  const { _isSuperAdminDeveloper } = settings ?? {}
  const mds = _projectAppNames
  const opts = Object.keys(mds).map(item => {
    const icon = getDataSourceItem(item)
    const _item = { text: _.startCase(item), icon, color: 'blue', lmt: leftMenuTriggerTypes.dataOrigin, frt: item }
    return { ...getOptions(h_ta, null, null, _item).default }
  })
  opts.unshift(...closers(getOptions(hs_cmt).dataOrigin, hs_cmt))
  return optionAccess(settings, _optionTypes.dataOrigin) && opts
}

const options_dataSources = (handlers, settings) => {
  const { handleSet_currentMenuType: hs_cmt, handle_triggerAction: h_ta } = handlers ?? {}
  const { appDataSource, _appDataSourceType } = settings ?? {}
  const { appDataSourceType } = appDataSource ?? {}
  const _adst = _appDataSourceType ? _appDataSourceType : appDataSourceType
  const mds = gEnums.dataSourceTypes
  const opts = Object.keys(mds).map(item => {
    const icon = getDataSourceItem(item)

    const _item = { text: _.startCase(item), icon, color: 'blue', lmt: leftMenuTriggerTypes.dataSource, frt: item, color: _adst === item ? 'blue' : 'grey' }
    return { ...getOptions(h_ta, null, null, _item).default }
  })
  opts.unshift(...closers(getOptions(hs_cmt).dataSource, hs_cmt))
  return optionAccess(settings, _optionTypes.dataSource) && opts
}

const options_dashboard = (handlers, settings) => {
  const { handleSet_currentMenuType: hs_cmt, handle_triggerAction: h_ta } = handlers ?? {}
  const { isEvent, isClient, _appSettingsOriginType } = settings ?? {}

  const opts = []

  let text = 'Settings'

  let ico = {
    name: null,
    color: 'grey',
    showc: false,
  }

  let iconCorner;
  let iconCornerColor;

  switch (_appSettingsOriginType) {
    case _appSettingsOriginTypes.settings:
      text += ' (App)'
      ico.color = 'grey'
      break;
    case _appSettingsOriginTypes.cache:
      text += ' (Cache)'
      ico.color = 'green'
      iconCorner = 'paint brush'
      iconCornerColor = 'blue'
      break;
    case _appSettingsOriginTypes.googleSheets:
      text += ' (Google Sheets)'
      ico.color = 'grey'
      iconCorner = 'google'
      iconCornerColor = 'blue'
      break;
    default:
      text += ' (database)'
  }

  opts.push({
    text: text,
    icon: appIconTypes.settings,
    oc: h_ta,
    lmt: leftMenuTriggerTypes.settings,
    frt: frameworkLeftTypes.settings,
    color: ico.color,
    showIconCorner: true,
    iconCorner,
    iconCornerColor,
  })

  optionAccess(settings, _optionTypes.dashboard) && opts.push(getOptions(hs_cmt).dashboard)

  // only show if it is an event
  isEvent && opts.push({ text: 'App Data', icon: appIconTypes.list, oc: h_ta, lmt: leftMenuTriggerTypes.frameworkLeft, frt: frameworkLeftTypes.appData, dividerBefore: true })

  optionAccess(settings, _optionTypes.admin) && opts.push(getOptions(hs_cmt).admin)
  optionAccess(settings, _optionTypes.appAdmin) && opts.push(getOptions(hs_cmt).appAdmin)

  return opts
}

const options_admins = (handlers, settings) => {

  const { handleSet_currentMenuType: hs_cmt, handle_triggerAction: h_ta } = handlers ?? {}
  const { permissionGroups } = settings ?? {}
  const { admin } = permissionGroups ?? {}

  const showCaption = true
  const opts = []

  if (admin) {
    _.forEach(admin, (item) => {
      const { viewItem, segProps } = item
      const { key } = viewItem
      const { caption, icon } = segProps ?? {}
      const color = gEnums.accessLevels.admin.color
      let frt;
      let dividerBefore;
      switch (key) {
        case 'appProfilesManager':
          frt = frameworkLeftTypes.appProfilesManager
          dividerBefore = true
          break;
        case 'appUsersManager':
          frt = frameworkLeftTypes.appUsersManager
          break;
        default:
        // nothing
      }
      opts.push({ text: caption, icon: icon, showCaption, color, oc: h_ta, lmt: leftMenuTriggerTypes.frameworkLeft, frt: frt, dividerBefore })
    })
  }

  opts.unshift(...closers(getOptions(hs_cmt, { name: 'users' }).admin, hs_cmt))
  return optionAccess(settings, _optionTypes.admin) && opts
}

const options_appAdmins = (handlers, settings) => {
  const { handleSet_currentMenuType: hs_cmt, handle_triggerAction: h_ta } = handlers ?? {}
  const { permissionGroups } = settings ?? {}
  const { appAdmin, ticketing } = permissionGroups ?? {}

  const showCaption = true
  const opts = []

  if (appAdmin) {
    let dividerBefore = true
    const color = gEnums.accessLevels.appAdmin.color
    _.forEach(appAdmin, (item) => {
      const { itemKey, segProps } = item
      const { caption, icon } = segProps ?? {}
      opts.push({ text: caption, icon, showCaption, color, oc: h_ta, lmt: leftMenuTriggerTypes.frameworkLeft, frt: itemKey, dividerBefore })
      dividerBefore = false
    })
  }

  if (ticketing) {
    let dividerBefore = true
    const color = gEnums.accessLevels.appAdmin.color
    _.forEach(ticketing, (item) => {
      const { itemKey, segProps } = item
      const { caption, icon } = segProps ?? {}
      opts.push({ text: caption, icon, showCaption, color, oc: h_ta, lmt: leftMenuTriggerTypes.frameworkLeft, frt: itemKey, dividerBefore })
      dividerBefore = false
    })
  }

  opts.unshift(...closers(getOptions(hs_cmt, { name: 'users' }).appAdmin, hs_cmt))
  return optionAccess(settings, _optionTypes.appAdmin) && opts
}

const options_home = (handlers, settings) => {

  const { handleSet_currentMenuType: hs_cmt, handle_triggerAction: h_ta } = handlers ?? {}

  const { showLeftMenuCaptions, demoOn, online, offline, appArea, pathViews, appUsersPresense } = settings ?? {}

  const opts = []

  if (appUsersPresense) {
    opts.push({ text: 'Online', icon: 'users', color: 'green', count: online ? online.length : '0', oc: handlers.handleShow_frameworkLeft, frt: frameworkLeftTypes.appUsersPresense })
    opts.push({ text: 'Offline', icon: 'users', color: 'yellow', count: offline ? offline.length : '0' })
  }

  pathViews && pathViews.events && opts.push({ text: 'Goto Client', icon: settingsIconTypes.client, oc: h_ta, lmt: leftMenuTriggerTypes.gotoClient, iconCorner: 'arrow left', dividerBefore: true })
  opts.push({ text: 'Goto Home', icon: appIconTypes.home, oc: h_ta, lmt: leftMenuTriggerTypes.gotoHome, iconCorner: 'arrow left' })
  opts.push(getOptions(hs_cmt).appHistory)
  opts.push({ text: 'Goto Demo', icon: 'eye', oc: h_ta, lmt: leftMenuTriggerTypes.gotoDemo, iconCorner: 'arrow left', dividerBefore: true, color: demoOn ? 'green' : null })

  opts.push(getOptions(hs_cmt).appInfo)
  opts.push({ text: showLeftMenuCaptions ? 'Close Menu' : 'Show Menu', icon: showLeftMenuCaptions ? 'arrow left' : 'arrow right', oc: h_ta, lmt: leftMenuTriggerTypes.toggle, dividerBefore: true, color: 'grey' })

  return optionAccess(settings, _optionTypes.home) && opts
}

const options_overrides = (handlers, settings) => {

  const { handle_triggerAction: h_ta } = handlers ?? {}

  const { authOn, helpOn, dataOverrideOn, demoOverrideOn, prodOverrideOn, altDatabaseOn, settingsPreviewOn, isEvent, appArea, appEnv, appUserAuthList } = settings ?? {}
  const { recent, found, notFound } = appUserAuthList ?? {}

  const _counts = {
    br: recent ? _.size(recent) : '0',
    tr: found ? _.size(found) : '0',
    tl: notFound ? _.size(notFound) : '0',
  }

  const opts = []

  isEvent && opts.push({ text: 'Demo', icon: 'terminal', color: demoOverrideOn ? 'green' : 'grey', oc: h_ta, lmt: leftMenuTriggerTypes.demoOverride, dividerBefore: true, iconCorner: demoOverrideOn ? 'check' : null, iconCornerColor: 'grey' })
  isEvent && opts.push({ text: 'Prod Override', icon: 'product hunt', color: prodOverrideOn ? 'green' : 'grey', oc: h_ta, lmt: leftMenuTriggerTypes.prodOverride, dividerBefore: true, iconCorner: prodOverrideOn ? 'check' : null, iconCornerColor: 'grey' })
  isEvent && opts.push({ text: 'Data Override', icon: 'unhide', color: dataOverrideOn ? 'green' : 'grey', oc: h_ta, lmt: leftMenuTriggerTypes.dataOverride, dividerBefore: true, iconCorner: dataOverrideOn ? 'check' : null, iconCornerColor: 'grey' })
  opts.push({ text: 'Help', icon: 'help circle', color: helpOn ? 'green' : 'grey', oc: h_ta, lmt: leftMenuTriggerTypes.help, iconCorner: helpOn ? 'check' : null, iconCornerColor: 'grey', dividerBefore: !isEvent })
  appArea === 'event' && opts.push({ counts: _counts, text: 'Auth', icon: 'users', color: authOn ? 'green' : 'grey', oc: h_ta, lmt: leftMenuTriggerTypes.auth, iconCorner: authOn ? 'check' : null, iconCornerColor: 'grey' })
  opts.push({ text: 'Live Settings', icon: 'settings', color: settingsPreviewOn ? 'green' : 'grey', oc: h_ta, lmt: leftMenuTriggerTypes.settingsPreview, iconCorner: helpOn ? 'check' : null, iconCornerColor: 'grey', })
  opts.push({ text: appEnv === envTypes.development ? 'Prod Settings' : 'Dev Settings', icon: 'setting', color: altDatabaseOn ? 'green' : 'grey', oc: h_ta, lmt: leftMenuTriggerTypes.altDatabase, iconCorner: helpOn ? 'check' : null, iconCornerColor: 'grey', })

  return optionAccess(settings, _optionTypes.overrides) && opts
}

const options_externals = (handlers, settings) => {

  const { handle_triggerAction: h_ta, handleSet_currentMenuType: hs_cmt } = handlers ?? {}

  const { _isSuperAdminDeveloper, isLocal, appEnv, allowGoogleSheets, googleSheetsId, appArea } = settings ?? {}

  const opts = []
  const cornerIcon = 'external alternate'

  _isSuperAdminDeveloper && opts.push({ ...getOptions(h_ta, null, cornerIcon, { text: 'Open Database', icon: 'database', color: 'orange', lmt: leftMenuTriggerTypes.openDb }).gotoExternal })
  _isSuperAdminDeveloper && opts.push({ ...getOptions(h_ta, null, cornerIcon, { text: 'Open Settings Database', icon: 'database', color: 'orange', lmt: leftMenuTriggerTypes.settingsDb }).gotoExternal })
  _isSuperAdminDeveloper && opts.push({ ...getOptions(h_ta, null, cornerIcon, { text: 'Open Storage', icon: 'server', color: 'orange', lmt: leftMenuTriggerTypes.openStorage }).gotoExternal })
  allowGoogleSheets && googleSheetsId && opts.push({ ...getOptions(h_ta, null, cornerIcon, { text: 'Open Google Sheets', icon: 'google drive', color: 'orange', lmt: leftMenuTriggerTypes.openGs }).gotoExternal })

  isLocal && opts.push({ ...getOptions(h_ta, null, cornerIcon, { text: 'Dev', icon: 'sitemap', color: 'grey', lmt: leftMenuTriggerTypes.gotoDev }).gotoExternal })
  opts.push({ ...getOptions(h_ta, null, cornerIcon, { text: appEnv === envTypes.development ? 'Prod' : 'Dev', icon: 'sitemap', color: 'orange', lmt: leftMenuTriggerTypes.gotoSite }).gotoExternal })

  opts.unshift(...closers(getOptions(hs_cmt).external, hs_cmt))

  return optionAccess(settings, _optionTypes.externals) && opts
}

const options_dashboards = (handlers, settings) => {
  const { handleSet_currentMenuType: hs_cmt, handle_triggerAction: h_ta } = handlers ?? {}
  const { appUserAccess, allowSd, allowGf, dashboardType, pathViews } = settings ?? {}
  const { clients, events } = pathViews ?? {}
  const _isClient = clients && !events
  const _isEvent = clients && events
  const opts = []
  const showCaption = true

  const altOpts = { showCaption, oc: h_ta, lmt: leftMenuTriggerTypes.dashboard }

  opts.push({ text: 'App Dashboard', ...altOpts, icon: appIconTypes.appDashboard, color: 'blue', dividerBefore: true })

  let _adms;

  if (!clients) {
    _adms = allDataModes_home
  } else {
    _adms = _isEvent ? allDataModes_event : allDataModes_client
  }

  if (!appUserAccess.isAdminOrSuper) {
    _adms = _.omitBy(_adms, (value) =>
      [allDataModes.deleteEvent, allDataModes.recreateEvent].includes(value)
    );
  }

  _.each(_adms, (adm) => {
    opts.push({ text: _.startCase(adm), ...altOpts, frt: adm, icon: appIconTypes[adm] })
  })

  // sports
  allowSd && opts.push({ text: dashboardType + ' Dashboard', ...altOpts, icon: appIconTypes.sports, frt: frameworkDashboardTypes.sportsViewer, dividerBefore: true })
  allowGf && opts.push({ text: dashboardType + ' Dashboard!!', ...altOpts, icon: appIconTypes.sports, frt: frameworkDashboardTypes.golfViewer, dividerBefore: true })

  opts.unshift(...closers(getOptions(hs_cmt).dashboard, hs_cmt))
  return optionAccess(settings, _optionTypes.dashboards) && opts
}

const options_actions = (handlers, settings) => {
  const { handleSet_currentMenuType: hs_cmt, handle_triggerAction: h_ta } = handlers ?? {}
  const { allowAppDataDocumentsUpdate, pathViews } = settings ?? {}
  const { clients, events } = pathViews ?? {}
  const _isClient = clients && !events
  const _isEvent = clients && events
  const showCaption = true
  const altOpts = { showCaption, oc: h_ta }

  const _noOptions = !_isClient && !allowAppDataDocumentsUpdate
  const opts = []
  _noOptions && opts.push({ text: 'No Actions', showCaption })
  if (allowAppDataDocumentsUpdate) {
    opts.push({ text: 'Create Documents', ...altOpts, icon: 'arrow right', color: 'blue', dividerBefore: true, lmt: leftMenuTriggerTypes.appDataDocuments, useConfirm: true })
    opts.push({ text: 'Create App Links', ...altOpts, icon: 'arrow right', color: 'blue', lmt: leftMenuTriggerTypes.appDataLinks, useConfirm: true })
    opts.push({ text: 'Create App Profiles', ...altOpts, icon: 'arrow right', color: 'blue', lmt: leftMenuTriggerTypes.appProfiles, useConfirm: true })
    opts.push({ text: 'Demo App From Google Sheet', ...altOpts, icon: 'arrow right', color: 'blue', lmt: leftMenuTriggerTypes.demoApp, useInput: true })

  }
  _isClient && opts.push({ text: 'Create New Event', ...altOpts, icon: 'arrow right', color: 'blue', lmt: leftMenuTriggerTypes.frameworkLeft, frt: frameworkLeftTypes.createNewEvent })
  _isEvent && opts.push({ text: 'Duplicate Event', ...altOpts, icon: 'arrow right', color: 'blue', lmt: leftMenuTriggerTypes.frameworkLeft, frt: frameworkLeftTypes.recreateNewEvent })
  opts.push({ text: 'Refresh Cache', ...altOpts, icon: 'redo', color: 'blue', lmt: leftMenuTriggerTypes.triggerAction, frt: frameworkLeftTypes.refreshCache })
  opts.push({ text: 'Clear Cache', ...altOpts, icon: 'remove', color: 'red', lmt: leftMenuTriggerTypes.triggerAction, frt: frameworkLeftTypes.clearCache })
  opts.push({ text: 'Clear Cache Data', ...altOpts, icon: 'remove', color: 'red', lmt: leftMenuTriggerTypes.triggerAction, frt: frameworkLeftTypes.clearCacheData })
  opts.push({ text: 'Clear Cache Settings', ...altOpts, icon: 'remove', color: 'red', lmt: leftMenuTriggerTypes.triggerAction, frt: frameworkLeftTypes.clearCacheSettings })
  opts.push({ text: 'Update Manifest', ...altOpts, icon: 'save', color: 'blue', lmt: leftMenuTriggerTypes.triggerAction, frt: frameworkLeftTypes.updateManifest })
  opts.unshift(...closers(getOptions(hs_cmt).action, hs_cmt))
  return optionAccess(settings, _optionTypes.action) && opts
}

const closers = (options, hs_cmt) => {
  const { text } = options ?? {}
  const opts = []
  // opts.push({ text: text, icon: appIconTypes.delete, oc: hs_cmt, color: 'red', showCaption: true })
  return opts
}